import classNames from 'classnames';
import React from 'react';
import FixedNotifications from '../../components/fixed-notifications/fixed-notifications';
import { MainHeader } from '../../components/header/main-header/main-header';
import { SessionChecker } from '../../components/session-checker/session-checker';
import { NotificationsContainer } from '../../containers/notifications/notifications';
import styles from './onboarding.scss';

interface Props {
  children: any;
}

const OnBoardingLayout = ({ children }: Props) => {
  return (
    <div className={classNames('ltr', styles.root)}>
      <SessionChecker />

      <FixedNotifications fullWidth>
        <NotificationsContainer />
      </FixedNotifications>

      <MainHeader />

      <div className={styles.userContent}>{children}</div>
    </div>
  );
};

export default OnBoardingLayout;
